
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Profile({profile, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{profile?.lib}</td>
            <td>{profile?.ident}</td>
            <td>{profile.libespacetravail ? profile?.libespacetravail : ""}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (profile?.etat === 1) ? 'badge-warning' :
                        (profile?.etat === 2) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {profile?.etatdef}
                </div>
            </td>
            <td>{profile?.datecrea ? <ReactTimeAgo date={Date.parse(profile?.datecrea)} timeStyle="facebook" /> : ""}</td>
            <td className="text-center">
                <Link to={`/profile/${profile?.code}`} data-toggle="tooltip" title="View profile" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}